import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PartyPopper, X } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";

export const WelcomeBackBanner = () => {
  const { user, refresh } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const [hidden, setHidden] = useState(false);

  if (!user || !user.welcome_back || hidden) return null;

  const dismiss = async () => {
    setHidden(true);
    try { await api.post("/auth/welcome-back/dismiss"); } catch {/* best-effort */}
    refresh();
  };

  const renew = async () => {
    await dismiss();
    navigate("/subscription");
  };

  return (
    <div
      className="bg-amber-50 border-b border-amber-200 text-espresso px-4 sm:px-6 py-3 flex flex-wrap items-center gap-3"
      data-testid="welcome-back-banner"
      data-print-hide
    >
      <PartyPopper className="w-5 h-5 text-amber-600 shrink-0" />
      <div className="flex-1 min-w-[200px]">
        <div className="text-sm font-semibold">{t("welcome_back.title").replace("{name}", user.name || "")}</div>
        <div className="text-xs text-espresso/70">{t("welcome_back.body")}</div>
      </div>
      <button
        type="button"
        onClick={renew}
        className="px-4 py-1.5 rounded-full bg-olive text-white text-sm font-semibold hover:bg-olive/90 transition-colors"
        data-testid="welcome-back-renew-button"
      >
        {t("welcome_back.renew")}
      </button>
      <button type="button" onClick={dismiss} className="opacity-60 hover:opacity-100 transition-opacity" aria-label="Dismiss" data-testid="welcome-back-dismiss">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
